import { FC, ReactNode } from 'react';
import { useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    chance: number;
    feelsLike: number;
    icon: ReactNode;
    location: string;
    rain: number;
    temperature: number;
};

export const Weather: FC<propsType> = ({ chance, feelsLike, icon, location, rain, temperature }) => {
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();

    return (
        <div className={`animate__animated animate__bounceInDown ${isDarkMode ? 'text-white' : ''}`}>
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    gap: isMobile ? undefined : '0.5rem',
                    justifyContent: 'center',
                    marginTop: isMobile ? 0 : '0px'
                }}
            >
                <div className={'row d-flex justify-content-center w-100'}>
                    <div className={'p-0'} style={{ order: isMobile ? 2 : 1, width: isMobile ? undefined : '16%' }}>
                        <div className={'d-flex align-items-center flex-column'}>
                            <h1 style={{ fontSize: isMobile ? '4rem' : '4rem', fontWeight: 100 }}>
                                {Math.ceil(temperature)}
                                <small>ºC</small>
                            </h1>
                            <span className={isMobile ? 'mb-3' : ''} style={{ fontSize: isMobile ? '1.2rem' : '1rem', fontWeight: 500 }}>
                                {location}
                            </span>
                        </div>
                    </div>
                    <div className={'p-0'}
                        style={{ order: isMobile ? 1 : 2, maxWidth: isMobile ? '100px' : '120px' }}
                    >
                        {icon}
                    </div>
                </div>
                {isMobile ?
                    <div className={'text-center'}>
                        <h6>
                            Sensación térmica: {feelsLike}°C
                        </h6>
                        <h6>
                            Precipitaciones: {rain}mm
                        </h6>
                        <h6>
                            Chance lluvia próximas 3hs: {chance}%
                        </h6>
                    </div>
                    :
                    <ul style={{ 
                        display: 'flex',
                        fontSize: isMobile ? '1rem' : '1.25rem',
                        flexWrap: isMobile ? 'wrap' : undefined,
                        justifyContent: isMobile ? 'center' : '',
                        gap: isMobile ? '0.25rem 1rem' : ''
                    }}>
                        <li className={'mx-4'}>
                            <span style={{ fontSize: '1rem' }}>
                                Sensación térmica: {feelsLike}ºC
                            </span>
                        </li>
                        <li className={'mx-4'}>
                            <span style={{ fontSize: '1rem' }}>
                                Precipitaciones: {rain}mm
                            </span>
                        </li>
                        <li className={'mx-4'}>
                            <span style={{ fontSize: '1rem' }}>
                                Chance lluvia próximas 3hs: {chance}%
                            </span>
                        </li>
                    </ul>
                }
            </div>
        </div>
    );
}
